<mat-dialog-content class="container">
	<div class="flex column">
		<div class="flex space-between">
			<h4>{{data.title}}</h4>
			<button class="align-end" mat-icon-button (click)="dismiss()"> <mat-icon>close</mat-icon> </button>
		</div>
		<hr>
		<h5>{{'manage-clients.search_clients_to_assign' | translateWithKeys}}</h5>
		<div class="w-100">
			<app-clients 
				[contentCreators]="filteredContentCreators"
				[previouslySelectedContentCreators]="selectedContentCreators" 
				[onlyTable]="true"
				(selectedContentCreatorsChange)="selectedContentCreators = $event"
				(searchTermChange)="onSearchTermChange($event)">
			</app-clients>
		</div>
	</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<div class="flex row end gap-12">
		<button mat-stroked-button class="button" (click)="decline()">{{ (data.dismissBtnText ?? 'general.dismiss') |
			translateWithKeys }}</button>
		<button mat-stroked-button class="button" [ngClass]="data.btnColor" (click)="accept()">{{ (data.acceptBtnText ??
			'general.continue') | translateWithKeys }}</button>
	</div>
</mat-dialog-actions>